import { HDate, months } from '@hebcal/core';
import { DataBroker } from './DataBroker';
import { HebDateUtil } from './HebDateUtil';


const PRAKIM = [
	{	"name": "תניא",
		"prakim":	[	{ key:1, name:"שער", start: 1, end: 1 },
						{ key:2, name:"הסכמות", start: 2, end: 3 },
						{ key:3, name:"הקדמת המלקט", start: 4, end: 6 }			
					]
	},
	{	"name": "חלק ראשון: ספר של בינונים",
		"title": "ספר של בינונים",
		"wide": true,
		"prakim":	[	{ key:4, name:"פרק א", start: 7, end: 8 },
						{ key:5, name:"פרק ב", start: 9, end: 9 },
						{ key:6, name:"פרק ג", start: 10, end: 11 },
						{ key:7, name:"פרק ד", start: 12, end: 17 },
						{ key:8, name:"פרק ה", start: 18, end: 19 },
						{ key:9, name:"פרק ו", start: 20, end: 23 },
						{ key:10, name:"פרק ז", start: 24, end: 26 },
						{ key:11, name:"פרק ח", start: 27, end: 28 },
						{ key:12, name:"פרק ט", start: 29, end: 31 },
						{ key:13, name:"פרק י", start: 32, end: 35 },
						{ key:14, name:"פרק יא", start: 36, end: 36 },
						{ key:15, name:"פרק יב", start: 37, end: 41 },
						{ key:16, name:"פרק יג", start: 42, end: 45 },
						{ key:17, name:"פרק יד", start: 46, end: 48 },
						{ key:18, name:"פרק טו", start: 49, end: 51 },
						{ key:19, name:"פרק טז", start: 52, end: 53 },
						{ key:20, name:"פרק יז", start: 54, end: 57 },
						{ key:21, name:"פרק יח", start: 58, end: 60 },
						{ key:22, name:"פרק יט", start: 61, end: 63 },
						{ key:23, name:"פרק כ", start: 64, end: 67 },
						{ key:24, name:"פרק כא", start: 68, end: 71 },
						{ key:25, name:"פרק כב", start: 72, end: 73 },
						{ key:26, name:"פרק כג", start: 74, end: 80 },
						{ key:27, name:"פרק כד", start: 81, end: 83 },
						{ key:28, name:"פרק כה", start: 84, end: 90 },
						{ key:29, name:"פרק כו", start: 91, end: 93 },
						{ key:30, name:"פרק כז", start: 94, end: 100 },
						{ key:31, name:"פרק כח", start: 101, end: 102 },
						{ key:32, name:"פרק כט", start: 103, end: 112 },
						{ key:33, name:"פרק ל", start: 113, end: 118 },
						{ key:34, name:"פרק לא", start: 119, end: 122 },
						{ key:35, name:"פרק לב", start: 123, end: 128 },
						{ key:36, name:"פרק לג", start: 129, end: 131 },
						{ key:36, name:"פרק לד", start: 132, end: 135 },
						{ key:37, name:"פרק לה", start: 136, end: 141 },
						{ key:38, name:"פרק לו", start: 142, end: 146 },
						{ key:39, name:"פרק לז", start: 147, end: 158 },
						{ key:40, name:"פרק לח", start: 159, end: 164 },
						{ key:41, name:"פרק לט", start: 165, end: 172 },
						{ key:42, name:"פרק מ", start: 173, end: 179 },
						{ key:43, name:"פרק מא", start: 180, end: 190 },
						{ key:44, name:"פרק מב", start: 191, end: 197 },
						{ key:45, name:"פרק מג", start: 198, end: 200 },
						{ key:46, name:"פרק מד", start: 201, end: 205 },
						{ key:47, name:"פרק מה", start: 206, end: 207 },
						{ key:48, name:"פרק מו", start: 208, end: 214 },
						{ key:49, name:"פרק מז", start: 215, end: 215 },
						{ key:50, name:"פרק מח", start: 216, end: 222 },
						{ key:51, name:"פרק מט", start: 223, end: 228 },
						{ key:52, name:"פרק נ", start: 229, end: 230 },
						{ key:53, name:"פרק נא", start: 231, end: 235 },
						{ key:54, name:"פרק נב", start: 236, end: 240 },
						{ key:55, name:"פרק נג", start: 241, end: 243 }
					]
	},
	
	{	"name": "חלק שני: שער היחוד והאמונה",
		"title": "שער היחוד והאמונה",
		"wide": true,
		"prakim":	[	{ key:56, name:"חינוך קטן", start: 244, end: 246, hidePerek: false },
						{ key:57, name:"פרק א", start: 247, end: 248 },
						{ key:58, name:"פרק ב", start: 249, end: 250 },
						{ key:59, name:"פרק ג", start: 251, end: 253 },
						{ key:60, name:"פרק ד", start: 254, end: 256 },
						{ key:61, name:"פרק ה", start: 257, end: 257 },
						{ key:62, name:"פרק ו", start: 258, end: 260 },
						{ key:63, name:"פרק ז", start: 261, end: 270 },
						{ key:64, name:"פרק ח", start: 271, end: 272 },
						{ key:65, name:"פרק ט", start: 273, end: 275 },
						{ key:66, name:"פרק י", start: 276, end: 278 },
						{ key:67, name:"פרק יא", start: 279, end: 280 },
						{ key:68, name:"פרק יב", start: 281, end: 282 }
					]
	},
	{	"name": "חלק שלישי: אגרת התשובה",
		"title": "אגרת התשובה",
		"wide": true,
		"prakim":	[	{ key:69, name:"פרק א", start: 283, end: 284 },
						{ key:70, name:"פרק ב", start: 285, end: 285 },
						{ key: 71, name:"פרק ג", start: 286, end: 289 },
						{ key:72, name:"פרק ד", start: 290, end: 294 },
						{ key:73, name:"פרק ה", start: 295, end: 295 },
						{ key:74, name:"פרק ו", start: 296, end: 297 },
						{ key:75, name:"פרק ז", start: 298, end: 300 },
						{ key:76, name:"פרק ח", start: 301, end: 302 },
						{ key:77, name:"פרק ט", start: 303, end: 303 },
						{ key:78, name:"פרק י", start: 304, end: 305 },
						{ key:79, name:"פרק יא", start: 306, end: 308 },
						{ key:80, name:"פרק יב", start: 309, end: 309 }
					]
	},
	{	"name": "אגרת הקודש",
		"title": "אגרת הקודש",
		"wide": true,
		"prakim":	[	{ key:81, name:"סימן א",  start: 310, end: 312 },
						{ key: 82, name:"סימן ב",  start: 313, end: 313 },
						{ key:83, name:"סימן ג",  start: 314, end: 315 },
						{ key:84, name:"סימן ד",  start: 316, end: 319 },
						{ key:85, name:"סימן ה",  start: 320, end: 327 },
						{ key:86, name:"סימן ו",  start: 328, end: 329 },
						{ key:87, name:"סימן ז",  start: 330, end: 333 },
						{ key:88, name:"סימן ח",  start: 334, end: 337 },
						{ key:89, name:"סימן ט",  start: 338, end: 339 },
						{ key:90, name:"סימן י",  start: 340, end: 344 },
						{ key:91, name:"סימן יא", start: 345, end: 346 },
						{ key:92, name:"סימן יב", start: 347, end: 352 },
						{ key:93, name:"סימן יג", start: 353, end: 355 },
						{ key:94, name:"סימן יד", start: 356, end: 358 },
						{ key:95, name:"סימן טו", start: 359, end: 364 },
						{ key:96, name:"סימן טז", start: 365, end: 366 },
						{ key:97, name:"סימן יז", start: 367, end: 369 },
						{ key:98, name:"סימן יח", start: 370, end: 371 },
						{ key:99, name:"סימן יט", start: 372, end: 376 },
						{ key:100, name:"סימן כ",  start: 377, end: 388 },
						{ key:101, name:"סימן כא", start: 389, end: 390 },
						{ key:102, name:"סימן כב", start: 391, end: 396 },
						{ key:103, name:"סימן כג", start: 397, end: 403 },
						{ key:104, name:"סימן כד", start: 404, end: 405 },
						{ key:105, name:"סימן כה", start: 406, end: 415 },
						{ key:106, name:"סימן כו", start: 416, end: 424 },
						{ key:107, name:"סימן כז", start: 425, end: 429 },
						{ key:108, name:"סימן כח", start: 430, end: 431 },
						{ key:109, name:"סימן כט", start: 432, end: 436 },
						{ key:110, name:"סימן ל",  start: 437, end: 437 },
						{ key:111, name:"סימן לא", start: 438, end: 438 },
						{ key:112, name:"סימן לב", start: 439, end: 439 }
					]
	},
	{	"name": "קונטרס אחרון",
		"prakim":	[	{ key:113, name:"הקורא סיפורי מעשיות", start: 440, end: 440 },
						{ key:114, name:"עיין ע\"ח שער הנקודות", start: 441, end: 441 },
						{ key:115, name:"להבין מ\"ש בשער היחודים", start: 442, end: 445 },
						{ key:116, name:"להבין מ\"ש בפע\"ח", start: 446, end: 458 },
						{ key:117, name:"ולהבין פרטי ההלכות דלא שכיחי", start: 459, end: 459 },
						{ key:118, name:"דוד זמירות קרית להו", start: 460, end: 461 },
						{ key:119, name:"וצדקה כנחל איתן", start: 462, end: 462 },
						{ key:120, name:"הנה לא טובה השמועה", start: 463, end: 463 },
						{ key:121, name:"הוכח תוכיח את עמיתך", start: 464, end: 464 }
					]
	}
];




function GetPerekIndex(perekId) {
	const perek = PRAKIM.map(p => p.prakim).flat().find(p => p.key == perekId);

	let output = [];
	for (let i=perek.start; i<=perek.end; i++)
		output.push(i);

	return output;
};

function RenderShiur(data) {
	return	<div className='Tanya'>
				<div dangerouslySetInnerHTML={{ __html: data }} />
			</div>;
};

export function GetPerekHeaderTN(perekId) {
	const sefer = PRAKIM.find(m => m.prakim.find(p => p.key == perekId));
	const perek = PRAKIM.map(p => p.prakim).flat().find(p => p.key == perekId);
	return (sefer.title && (perek.hidePerek===undefined||perek.hidePerek) ? sefer.title+" " : "") + perek.name;
};

export function GetPerekNextTN(perekId) {
	if (perekId == 121) 
		return 1;

	return ++perekId;
};
export function GetPerekPrevTN(perekId) {
	if (perekId == 1) 
		return 121;
	return --perekId;
};



export async function GetPerekTN(perekId) {
	const arrIndex = GetPerekIndex(perekId);

	let data = "";
	let loaded = true;

	for (let i=0; i<arrIndex.length; i++) {
		let tmp = await DataBroker.getDataText('tn/' + arrIndex[i]);
		data += tmp;

		if (tmp === null)
			loaded = false;
	}

	return new Promise((myResolve, myReject) => {
		if (!loaded)
			myReject(DataBroker.getError());
		else
			myResolve(RenderShiur(data));
	});
};

export function GetMenuTN() {
	return PRAKIM;
}